module.exports = __webpack_public_path__ + "img/AC_S6_Calendar.dbc6a980.jpg";